import { useEffect, useState, useMemo } from "react";
import cnBind from "classnames/bind";
import type { BreadCrumbProps } from "primereact/breadcrumb";
import { BreadCrumb as PrimereactBreadCrumb } from "primereact/breadcrumb";
import type { MenuItem } from "primereact/menuitem";
import { useRouter } from "next/router";
import { Routes } from "@/shared/constants/Routing";
import styles from "./BreadCrumb.module.scss";

const cx = cnBind.bind(styles);

type BreadCrumb = BreadCrumbProps;

const HOME_ITEM: MenuItem = { label: "Главная", url: Routes.HOME };
const BASE_URL = "https://liftmg.ru";

export const BreadCrumb = ({ model, ...props }: BreadCrumb) => {
    const router = useRouter();
    const [isMounted, setIsMounted] = useState(false);

    useEffect(() => {
        setIsMounted(true);
    }, []);

    const allItems = useMemo(() => {
        return model ? [HOME_ITEM, ...model] : [HOME_ITEM];
    }, [model]);

    const jsonLd = useMemo(() => {
        if (!isMounted) return null;

        return {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            "itemListElement": allItems.map((crumb: any, index) => {
                const currentUrl = crumb.url || router.asPath;
                const fullUrl = currentUrl.startsWith("http") ? currentUrl : `${BASE_URL}${currentUrl}`;

                return {
                    "@type": "ListItem",
                    "position": index + 1,
                    "name": crumb.label,
                    "item": fullUrl,
                };
            })
        };
    }, [allItems, router.asPath, isMounted]);

    return (
        <div
            className={cx("wrapper", "container")}
            style={{ minHeight: "40px", display: "flex", alignItems: "center" }}
        >
            {jsonLd && (
                <script
                    type="application/ld+json"
                    dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
                />
            )}
            {isMounted ? (
                <PrimereactBreadCrumb
                    separatorIcon="pi pi-angle-right"
                    className={cx("breadcrumb")}
                    home={HOME_ITEM}
                    model={model}
                    {...props}
                    pt={{ separator: { role: 'presentation', 'aria-hidden': 'true' } }}
                />
            ) : (
                <div style={{ height: "24px" }} />
            )}
        </div>
    );
};
